<!--
 * @Description: 
 * @Autor: lwq 没用的页面
 * @Date: 2020-08-12 20:59:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-19 17:47:36
 * @FilePath: \mrc-base-server-view\src\LAYOUT\components\main-content\index.vue
-->
<template>
  <div class="rightBigArea">
    <top-aside></top-aside>
    <v-divider></v-divider>
    <main-content></main-content>
  </div>
</template>

<script>
import topAside from './top-aside/index'
import mainContent from './content'
export default {
  components: { topAside, mainContent },
  props: {},
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {},
  computed: {},
  watch: {},
}
</script>

<style scoped>
.rightBigArea {
  height: 100%;
}
</style>
